import React, { useEffect, useState, useRef } from "react";
import { useTranslation, Trans } from 'react-i18next';

import { ReactComponent as HelpLogoSVG } from "@material-design-icons/svg/round/help.svg";
import { ReactComponent as HelpInfoLogoSVG } from "@material-design-icons/svg/round/info.svg";
import { ReactComponent as HelpQuestionLogoSVG } from "../../assets/img/Help_Question_Circle_White_200x200.svg";


export function HelpLogo({containerProps, containerStyle, props}) {
  return (
    <div style={{display:'inline', position:'relative', ...containerStyle}}  {...containerProps}  >
      <HelpLogoSVG fill='var(--purple-help)' {...props} />
    </div>
  );
}

export function HelpInfoLogo({containerProps, containerStyle, props}) {
  return (
    <div style={{display:'inline', position:'relative', ...containerStyle}}  {...containerProps}  >
      <HelpInfoLogoSVG fill='var(--purple-help)' {...props} />
    </div>
  );
}




export const HelperHelpDocsIcon = ({}) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  let letterSpacing = "-2px";
  let iconMarginTop = "-75px";
  let iconMarginBottom = "-83px";
  let textMarginBottom = ".25rem";
  let helperIconWidth="2.1rem";
  if (language == "en-US" || language == "en-GB" || /^en/i.test(language)) {
    letterSpacing = "-2px";
    iconMarginTop = "-75px";
    iconMarginBottom = "-83px";
    textMarginBottom = ".25rem";
    helperIconWidth="2.1rem";
  } else if (language == "cn" || /^cn/i.test(language) || /^zh/i.test(language)) {
    letterSpacing = "7px";
    iconMarginTop = "-79px";
    iconMarginBottom= "-76px";
    textMarginBottom="-.2rem";
    helperIconWidth="2.5rem";
   } else if (/^es/i.test(language)) {
    letterSpacing = "-2px";
    iconMarginTop = "-75px";
    iconMarginBottom = "-83px";
    textMarginBottom=".2rem";
    helperIconWidth="2.1rem";
  }
  return (
    <>
    <style>
    {`
      .helper-icon {
          display: inline-block;
          cursor: pointer;
          font-size: 1rem;
          color: white;
          background-color: #666666;
          border: 3px solid white;
          position: relative;
          width: ${helperIconWidth};
          border-radius: 5px 0 0 5px;
          padding-bottom: 1rem;
          border-right: none;
      }
      .helper-icon-text {
        position: relative;
        font-family: 'Nunito', sans-serif;
        font-size: 1.2rem;
        font-weight: bold;
        text-orientation: upright;
        writing-mode: vertical-rl;
        letter-spacing: ${letterSpacing};
        margin-bottom: ${textMarginBottom};
      }
      :has(>.circle-question-helpicon){
          display: flex;
          align-items: center;
          flex-direction: column;
      }
      .circle-question-helpicon {
        width: 76%;
        margin-top: ${iconMarginTop};
        margin-bottom: ${iconMarginBottom};
        }
      `}
    </style>
      <div className="helper-icon">
      <div style={{ display: 'flex', flexDirection:'column',  alignItems: 'center' }}>
        <HelpQuestionLogoSVG  className="circle-question-helpicon"   />
        <div className='helper-icon-text'>
          {t('icons.help')}
        </div>
      </div>
      </div>
    </>
  )
}

